<script>
/* eslint-disable */

export default {
  props: {
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
    travelMode: {
      type: String,
      required: true,
    },
    markers: {
      type: Array,
      required: true,
    },
    waypoints: {
      type: Array,
      required: true,
    },
    optimizeWaypoints: {
      type: Boolean,
      required: true,
    },
  },

  mounted() {
    const { DirectionsService, DirectionsRenderer } = this.google.maps;

    const directionsService = new DirectionsService();
    const directionsRenderer = new DirectionsRenderer();

    console.log('maps', this.map);

    if (this.markers.length > 0) {
      directionsRenderer.setMap(this.map.$mapObject);

      directionsService.route(
        {
          origin: this.markers[0].position,
          destination: this.markers[this.markers.length - 1].position,
          waypoints: this.waypoints,
          travelMode: this.google.maps.TravelMode.DRIVING,
          optimizeWaypoints: false,
          avoidTolls: true,
          provideRouteAlternatives: true,
          drivingOptions: {
            departureTime: new Date(),
            trafficModel: 'pessimistic',
          },
          unitSystem: this.google.maps.UnitSystem.IMPERIAL,
        },
        (response, status) => {
          if (status === 'OK' && response) {
            directionsRenderer.setDirections(response);
          } else {
            throw new Error('Directions request failed due to ' + status);
          }
        }
      );

    }
  },

  render() { },
};
</script>
